import {
  ADD_VIDEO,
  SET_VIDEO_UPLOADING_STATUS
} from './mutations-types'
import Videos from '../../../facebook/Videos'
import helpers from '../../../helpers/functions'

export default {
  fetchVideos ({ commit, dispatch }) {
    dispatch('startSpinner')
    let user = helpers.getCurrentUser()
    const facebook = new Videos(user)
    return new Promise((resolve, reject) => {
      resolve(facebook.fetchAccountVideos())
    })
      .then(res => {
        res.forEach(video => {
          const facebook = new Videos(user, {id: video.id})
          new Promise(resolve => {
            resolve(facebook.getVideoById())
          })
            .then(res => {
              commit(ADD_VIDEO, res)
              return true
            })
            .catch(err => {
              const error = JSON.parse(err.message)
              const response = error.response || {}
              let identifier
              if (response.error_subcode) identifier = response.error_subcode
              else if (response.message) identifier = response.message
              helpers.handleError(error, identifier, 'Facebook: ')
            })
        })
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  uploadVideo ({ commit, dispatch }, file) {
    commit(SET_VIDEO_UPLOADING_STATUS, true)
    let user = helpers.getCurrentUser()
    const facebook = new Videos(user, {file})
    return new Promise((resolve) => {
      resolve(facebook.uploadVideo())
    })
      .then(() => {
        return dispatch('fetchVideos')
      })
      .then(() => {
        dispatch('showNotification', {
          type: 'success',
          message: [`${file.name} has been uploaded`]
        })
        dispatch('stopSpinner')
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  deleteVideo ({ commit, dispatch }, id) {
    let user = helpers.getCurrentUser()
    const facebook = new Videos(user, {id})
    return new Promise((resolve, reject) => {
      resolve(facebook.deleteVideo())
    })
      .then(() => {
        console.log('deleted')
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  }
}
